import React from 'react';
import _ from 'underscore';
import { FormattedMessage, injectIntl } from 'react-intl';
import Popup from 'views/shared/ui/popup';
import { roundPrice } from 'lib/pricing_utils';
import './index.scss';

class CheckoutSummaryPricingBreakdown extends React.Component {
  static displayName = 'CheckoutSummaryPricingBreakdown';

  static defaultProps = {
    booking_fee_popup_content: null,
    units: {
      items: [],
    },
  };

  _renderAddonPricing = (addon, index) => {
    const { intl } = this.props;
    if (parseFloat(addon.total) === 0) {
      return null;
    }

    return (
      <div
        className="two column row"
        data-testid="addon-checkout-summary"
        key={index}
      >
        <div className="left aligned column PriceBreakDown-label">
          <div className="addonName">{addon.name}</div>
          <div className="addonBreakdown">
            <span className="addonPrice" data-testid="addon-price">
              {roundPrice(addon.unit_price_formatted)}
            </span>
            <span className="addonGuests" data-testid="addon-guests">
              {addon.per_person ? (
                ` x ${addon.guests}`
              ) : (
                <>
                  {' '}
                  {intl.formatMessage({
                    id: 'FOR_ALT',
                    defaultMessage: 'For',
                  })}{' '}
                  {addon.guests}
                </>
              )}
            </span>
          </div>
        </div>
        <div className="column PriceBreakDown-value" data-testid="addon-fee">
          {addon.total_formatted}
        </div>
      </div>
    );
  };

  _renderAddons = () => {
    const self = this;

    return _.map(this.props.addons.items, (addon, index) => {
      return self._renderAddonPricing(addon, index);
    });
  };

  _renderBookingFee = () => {
    if (this.props.includes_booking_fee) {
      return (
        <div className="two column row">
          <div className="left aligned column">
            <div className="BookingFee-Container">
              <span role="button" tabIndex="0" className="dotted">
                <FormattedMessage
                  id="SERVICE_FEE"
                  defaultMessage="Service fee"
                />
              </span>
              <span
                role="button"
                tabIndex="0"
                aria-label="service fee tooltip"
                aria-describedby="service-fee-desc"
                className="icon af-help-circle BookingFee-popup-target"
              />
              {this._renderBookingFeePopup()}
            </div>
          </div>
          <div
            className="column PriceBreakDown-value"
            data-testid="service-fee"
          >
            {this.props.booking_fee_formatted}
          </div>
        </div>
      );
    }
    return null;
  };

  _renderPricingUnits = () => {
    const { intl, units } = this.props;
    if (units.items === undefined) {
      return null;
    }
    return units.items
      .filter((unit) => {
        return unit.count > 0;
      })
      .map((unit) => {
        return (
          <div className="unit">
            {roundPrice(unit.unit_price_formatted)}&nbsp;
            {unit.per_tour === true
              ? intl.formatMessage({
                  id: 'FOR',
                  defaultMessage: 'for',
                })
              : 'x'}
            &nbsp;
            {unit.count}&nbsp;
            {unit.count === 1
              ? intl.formatMessage({
                  id: unit.noun_singular,
                  defaultMessage: unit.noun_singular,
                })
              : intl.formatMessage({
                  id: unit.noun_plural,
                  defaultMessage: unit.noun_plural,
                })}
            &nbsp;
          </div>
        );
      });
  };

  _renderPriceSummary = () => {
    return (
      <div className="two column row PriceBreakdown-summary">
        {this._renderPricingUnits()}
      </div>
    );
  };

  _renderSubtotal = () => {
    return [
      <div className="left aligned column">
        <FormattedMessage id="SUBTOTAL" defaultMessage="Subtotal" />
      </div>,
      <div className="column PriceBreakDown-value" data-testid="actual-value">
        {roundPrice(this.props.guests_price_formatted)}
      </div>,
    ];
  };

  _renderAdditionalTax = () => {
    if (this.props.includes_additional_tax) {
      return (
        <div className="two column row">
          <div className="left aligned column">
            {this.props.additional_tax_label}
          </div>
          <div className="column PriceBreakDown-value">
            {roundPrice(this.props.additional_tax_formatted)}
          </div>
        </div>
      );
    }
    return null;
  };

  _renderDiscount = () => {
    if (this.props.includes_discount) {
      return (
        <div className="two column row">
          <div className="left aligned column">
            <FormattedMessage id="PROMO_CODE" defaultMessage="Promo Code" />:{' '}
            <br />
            {this.props.discount_code}
          </div>
          <div
            className="column PriceBreakDown-value"
            data-testid="promo-value"
          >
            {roundPrice(this.props.discount_formatted)}
            <span className="toggleIconContainer">
              (<span className="icon af-minus-ar" />)
            </span>
          </div>
        </div>
      );
    }
    return null;
  };

  _renderOnlineDiscount = () => {
    if (this.props.includes_online_discount) {
      return (
        <div className="two column row">
          <div className="left aligned column">Online Payment Discount</div>
          <div className="column PriceBreakDown-value">
            {roundPrice(this.props.online_discount_formatted)}
            <span className="toggleIconContainer">
              (<span className="icon af-minus-ar" />)
            </span>
          </div>
        </div>
      );
    }
    return null;
  };

  serviceFeePopupContent = () => {
    const { intl, booking_fee_popup_content } = this.props;
    return (
    <div id="service-fee-desc">
      {booking_fee_popup_content ||
        intl.formatMessage({
          id: 'INCLUDES_CREDIT_CARD_PROCESSING_AND_SERVICE_PROVIDER_FEES',
          defaultMessage:
            'Includes credit card processing and service provider fees',
        })}
    </div>
  );
  };

  _renderBookingFeePopup = () => {
    return (
      <Popup
        content={this.serviceFeePopupContent()}
        target=".BookingFee-popup-target"
        identifier="popup-PriceBreakDown"
        position="bottom right"
        on="focus"
      />
    );
  };

  render() {
    return (
      <div className="PriceBreakDown">
        <div className="ui grid">
          <div className="two column row">
            {this._renderSubtotal()}
            {this._renderPriceSummary()}
          </div>
          {this._renderAddons()}
          {this._renderDiscount()}
          {this._renderAdditionalTax()}
          {this._renderOnlineDiscount()}
          {this._renderBookingFee()}
        </div>
      </div>
    );
  }
}

export default injectIntl(CheckoutSummaryPricingBreakdown);
